import React from "react";
import { withStyles } from "@mui/styles";

import FormHeader from "../../components/formHeader/FormHeader";
import SingleLineTextInput from "../../components/singleLineTextInput/SingleLineTextInput";
import Button from "../../components/button/Button";
import SuccessMessage from "../../components/successMessage/SuccessMessage";
import ErrorMessage from "../../components/errorMessage/ErrorMessage";

const isInvalidEmail = (email) => !email;
const isInvalidPassword = (password) => !password || password.length < 6;

const styles = (theme) => ({
  section: {
    width: "100%",
    backgroundColor: "#fff",
  },
  twoFields: {
    display: "flex",
    width: "100%",
  },
  authLink: {
    margin: "10px 0",
  },
});

function AcceptInviteForm({
  classes,
  onSubmit,
  message,
  error,
  registering,
  submitText,
}) {
  const [submitAttempted, setSubmitAttempted] = React.useState(false);
  const [payload, storePayload] = React.useState({});

  console.log(submitText);
  return (
    <div className={classes.section}>
      <div className={classes.setupInformation}>
        <FormHeader title="Accept invite" />
      </div>
      <SingleLineTextInput
        label="EMAIL ADDRESS"
        onChange={(value) => storePayload({ ...payload, emailAddress: value })}
        showInvalidInput={
          submitAttempted && isInvalidEmail(payload.emailAddress)
        }
        style={{ width: "100%" }}
        type="text"
      />
      <SingleLineTextInput
        label="NEW PASSWORD"
        onChange={(value) => storePayload({ ...payload, password: value })}
        showInvalidInput={
          submitAttempted && isInvalidPassword(payload.password)
        }
        style={{ width: "100%" }}
        type="password"
      />
      <ErrorMessage message={error} />
      <SuccessMessage message={message} />
      <Button
        title={submitText || "Submit"}
        onClick={() => {
          setSubmitAttempted(true);
          onSubmit(payload);
        }}
        submitting={registering}
      />
    </div>
  );
}

export default withStyles(styles)(AcceptInviteForm);
